// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';

/**
 * 회원가입 컴포넌트 속성 정의
 * 에디터의 속성 패널에서 사용할 속성 그룹 및 컨트롤 정의
 */
const SignupProperties = [
  {
    group: '기본 설정',
    properties: [
      {
        name: 'content.title',
        label: '제목',
        control: 'TextField',
        defaultValue: '회원가입'
      },
      {
        name: 'pathVariables.referralCode',
        label: '기본 추천인 코드',
        control: 'TextField',
        defaultValue: ''
      }
    ]
  },
  {
    group: '회원정보 필드 설정',
    properties: [
      {
        name: 'basicFields.userId',
        label: '아이디 필드 표시',
        control: 'Switch',
        defaultValue: true
      },
      {
        name: 'basicFields.password',
        label: '비밀번호 필드 표시',
        control: 'Switch',
        defaultValue: true
      },
      {
        name: 'basicFields.name',
        label: '이름 필드 표시',
        control: 'Switch',
        defaultValue: true
      },
      {
        name: 'basicFields.phone',
        label: '핸드폰 번호 필드 표시',
        control: 'Switch',
        defaultValue: true
      },
      {
        name: 'basicFields.email',
        label: '이메일 필드 표시',
        control: 'Switch',
        defaultValue: true
      },
      {
        name: 'basicFields.birthday',
        label: '생년월일 필드 표시',
        control: 'Switch',
        defaultValue: true
      },
      {
        name: 'basicFields.address',
        label: '주소 필드 표시',
        control: 'Switch',
        defaultValue: true
      },
      {
        name: 'basicFields.referralCode',
        label: '추천인 코드 필드 표시',
        control: 'Switch',
        defaultValue: true
      }
    ]
  },
  {
    group: '필드 설정',
    properties: [
      {
        name: 'varFields.var01.show',
        label: 'var01 필드 표시',
        control: 'Switch',
        defaultValue: false
      },
      {
        name: 'varFields.var01.label',
        label: 'var01 필드 이름',
        control: 'TextField',
        defaultValue: ''
      },
      {
        name: 'varFields.var01.type',
        label: 'var01 필드 타입',
        control: 'Select',
        options: [
          { value: 'input', label: '텍스트 입력' },
          { value: 'select', label: '선택 상자' },
          { value: 'radio', label: '라디오 버튼' },
          { value: 'document', label: '동의 문서' }
        ],
        defaultValue: 'input'
      },
      {
        name: 'varFields.var01.content',
        label: 'var01 필드 내용 (동의 문서일 경우)',
        control: 'TextArea',
        defaultValue: ''
      },
      {
        name: 'varFields.var01.required',
        label: 'var01 필드 필수 여부',
        control: 'Switch',
        defaultValue: false
      },
      
      // var02 필드 설정
      {
        name: 'varFields.var02.show',
        label: 'var02 필드 표시',
        control: 'Switch',
        defaultValue: false
      },
      {
        name: 'varFields.var02.label',
        label: 'var02 필드 이름',
        control: 'TextField',
        defaultValue: ''
      },
      {
        name: 'varFields.var02.type',
        label: 'var02 필드 타입',
        control: 'Select',
        options: [
          { value: 'input', label: '텍스트 입력' },
          { value: 'select', label: '선택 상자' },
          { value: 'radio', label: '라디오 버튼' },
          { value: 'document', label: '동의 문서' }
        ],
        defaultValue: 'input'
      },
      {
        name: 'varFields.var02.content',
        label: 'var02 필드 내용 (동의 문서일 경우)',
        control: 'TextArea',
        defaultValue: ''
      },
      {
        name: 'varFields.var02.required',
        label: 'var02 필드 필수 여부',
        control: 'Switch',
        defaultValue: false
      },
      
      // var03 필드 설정
      {
        name: 'varFields.var03.show',
        label: 'var03 필드 표시',
        control: 'Switch',
        defaultValue: false
      },
      {
        name: 'varFields.var03.label',
        label: 'var03 필드 이름',
        control: 'TextField',
        defaultValue: ''
      },
      {
        name: 'varFields.var03.type',
        label: 'var03 필드 타입',
        control: 'Select',
        options: [
          { value: 'input', label: '텍스트 입력' },
          { value: 'select', label: '선택 상자' },
          { value: 'radio', label: '라디오 버튼' },
          { value: 'document', label: '동의 문서' }
        ],
        defaultValue: 'input'
      },
      {
        name: 'varFields.var03.content',
        label: 'var03 필드 내용 (동의 문서일 경우)',
        control: 'TextArea',
        defaultValue: ''
      },
      {
        name: 'varFields.var03.required',
        label: 'var03 필드 필수 여부',
        control: 'Switch',
        defaultValue: false
      }
    ]
  },
  {
    group: '스타일',
    properties: [
      {
        name: 'style.backgroundColor',
        label: '배경색',
        control: 'ColorPicker',
        defaultValue: '#ffffff'
      },
      {
        name: 'style.borderRadius',
        label: '테두리 둥글기',
        control: 'TextField',
        defaultValue: '8px'
      },
      {
        name: 'style.boxShadow',
        label: '그림자',
        control: 'TextField',
        defaultValue: '0 2px 10px rgba(0, 0, 0, 0.1)'
      },
      {
        name: 'style.maxWidth',
        label: '최대 너비',
        control: 'TextField',
        defaultValue: '800px'
      },
      {
        name: 'style.margin',
        label: '여백',
        control: 'TextField',
        defaultValue: '0 auto'
      }
    ]
  }
];

export default SignupProperties; 